import { HttpResponse } from 'msw'
import {
  createCreateSupplementaryWorksheetsPayloadMock,
  CreateSupplementaryWorksheetsDocument,
  CreateSupplementaryWorksheetsMutation,
  CreateSupplementaryWorksheetsMutationVariables,
} from 'src/lib/gql-client'
import { graphQLHandlerFactory } from 'src/tests/mocks/handlerFactory'
import { generateUUID } from 'src/utils/generateUUID'

export const createSupplementaryWorksheetsHandler = graphQLHandlerFactory<
  CreateSupplementaryWorksheetsMutation,
  CreateSupplementaryWorksheetsMutationVariables
>('mutation', CreateSupplementaryWorksheetsDocument, () => {
  return HttpResponse.json({
    data: {
      createSupplementaryWorksheets:
        createCreateSupplementaryWorksheetsPayloadMock({
          worksheetUids: [generateUUID(), generateUUID(), generateUUID()],
        }),
    },
  })
})
